export const NOTI_TYPE = {
  ALL: 'all',
  COMMENT: 'comment',
  TAGGED: 'tagged',
  GUESTBOOK: 'guestbook',
  REPLY: 'reply',
  PRESENT: 'present',
  BATTLE: 'battle',
  QUEST_REQUEST: 'quest_request',
  CHAT: 'chat',
  DISPATCH_COMPLETE: 'dispatch_complete',
} as const;

export type NOTI_TYPE_KEY = keyof typeof NOTI_TYPE;
export type NOTI_TYPE_VALUE = typeof NOTI_TYPE[NOTI_TYPE_KEY];
